module.exports = __webpack_public_path__ + "img/logo-5.a32a211b.svg";